/*
 * PDP Call Strip — The Plant Guy
 * Paints live America/New_York availability on .tpg-strip nodes.
 * Re-queries the DOM every time. Do not cache a NodeList.
 */
(function () {
  if (window.__tpgCallStripInit) return;
  window.__tpgCallStripInit = true;

  var TZ = 'America/New_York';
  var DAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var PHONE_ICO =
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 3h3l1.5 4-2 1.5a13 13 0 0 0 6.5 6.5L17 13l4 1.5v3a2 2 0 0 1-2.2 2A17 17 0 0 1 4 5.2 2 2 0 0 1 6.5 3Z"></path></svg>';
  var VM_ICO =
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="12" r="3.6"></circle><circle cx="18" cy="12" r="3.6"></circle><path d="M6 15.6h12"></path></svg>';
  var intervalId = null;

  function nyNow() {
    var parts = {};
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    fmt.formatToParts(new Date()).forEach(function (part) {
      parts[part.type] = part.value;
    });
    var hour = +parts.hour;
    if (hour === 24) hour = 0;
    return { day: DAYS[parts.weekday], mins: hour * 60 + +parts.minute };
  }

  function compute(openHour, closeHour) {
    var t = nyNow();
    var weekday = t.day >= 1 && t.day <= 5;
    var openMins = openHour * 60;
    var closeMins = closeHour * 60;

    if (weekday && t.mins >= openMins && t.mins < closeMins) {
      return { state: t.mins >= closeMins - 30 ? 'soon' : 'online' };
    }

    var tomorrow = (t.day + 1) % 7;
    var backKey;
    if (weekday && t.mins < openMins) backKey = 'opensToday';
    else if (weekday && tomorrow >= 1 && tomorrow <= 5) backKey = 'backTomorrow';
    else backKey = 'backMonday';

    return { state: 'closed', backKey: backKey };
  }

  function applyToken(template, back) {
    if (!template) return back || '';
    return template.replace(/\[back\]/g, back || '');
  }

  function paint(el) {
    var result = compute(+el.dataset.openHour || 9, +el.dataset.closeHour || 17);
    var phone = el.dataset.phone || '';
    var l2El = el.querySelector('.tpg-strip__l2');
    var labelEl = el.querySelector('.tpg-strip__label');
    var icoEl = el.querySelector('.tpg-strip__ico');
    if (!l2El || !labelEl) return;

    var nextL2;
    var nextLabel;
    var nextIco;

    if (result.state === 'online') {
      nextL2 = (el.dataset.onlineL2 || '') + (phone ? ' · ' + phone : '');
      nextLabel = el.dataset.onlineLabel || '';
      nextIco = PHONE_ICO;
    } else if (result.state === 'soon') {
      nextL2 = (el.dataset.soonL2 || '') + (phone ? ' · ' + phone : '');
      nextLabel = el.dataset.soonLabel || '';
      nextIco = PHONE_ICO;
    } else {
      var back =
        result.backKey === 'opensToday'
          ? el.dataset.opensToday
          : result.backKey === 'backTomorrow'
            ? el.dataset.backTomorrow
            : el.dataset.backMonday;
      nextL2 = applyToken(el.dataset.closedL2, back || '');
      nextLabel = el.dataset.closedLabel || '';
      nextIco = VM_ICO;
    }

    if (el.dataset.state === result.state && l2El.textContent === nextL2 && labelEl.textContent === nextLabel) {
      return;
    }

    el.dataset.state = result.state;
    l2El.textContent = nextL2;
    labelEl.textContent = nextLabel;
    if (icoEl) icoEl.innerHTML = nextIco;
  }

  function paintAll() {
    document.querySelectorAll('.tpg-strip').forEach(paint);
  }

  function startInterval() {
    if (intervalId) return;
    intervalId = setInterval(paintAll, 60000);
  }

  function stopInterval() {
    if (!intervalId) return;
    clearInterval(intervalId);
    intervalId = null;
  }

  function init() {
    paintAll();
    if (document.querySelector('.tpg-strip')) startInterval();
    else stopInterval();
  }

  init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  document.addEventListener('shopify:block:select', paintAll);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, paintAll);
  }
})();
